import { render, staticRenderFns } from "./SeckillConfig.vue?vue&type=template&id=e11ab756&scoped=true"
import script from "./SeckillConfig.vue?vue&type=script&lang=js"
export * from "./SeckillConfig.vue?vue&type=script&lang=js"
import style0 from "./SeckillConfig.vue?vue&type=style&index=0&id=e11ab756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11ab756",
  null
  
)

export default component.exports